'use strict';
import * as goog from '../../_libs/google-closure-library';

const angular = require('angular');
const {isNumber, isObject} = angular;


FileRequirementEditorFactory.$inject = [
  'InPlaceEditorFactory',
];

export function FileRequirementEditorFactory(
  InPlaceEditorFactory,
) {

  function FileRequirementEditor(options) {
    options.update = function () {
      return options.getModel().update();
    };
    FileRequirementEditor.superClass_.constructor.call(this, options);
  }

  goog.inherits(FileRequirementEditor, InPlaceEditorFactory);

  FileRequirementEditor.prototype.onBlurMax = onBlurMax;
  FileRequirementEditor.prototype.onBlurMin = onBlurMin;

  return FileRequirementEditor;

  function onBlurMax() {
    const model = this.__config.getModel();
    if (isNumber(model.maximumFileCount)
      && isNumber(model.minimumFileCount)
      && model.maximumFileCount < model.minimumFileCount) {
      model.minimumFileCount = model.maximumFileCount;
    }
  }

  function onBlurMin() {
    const model = this.__config.getModel();
    if (isNumber(model.maximumFileCount)
      && isNumber(model.minimumFileCount)
      && model.maximumFileCount < model.minimumFileCount) {
      model.maximumFileCount = model.minimumFileCount;
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/requirements/services/FileRequirementEditorFactory.js